import { FC } from "react";
import { Image } from "../../../interface/interface";

export const Images: FC <Image> = ({source,alt,className}) => {
    return(
        <>
            <img src={source} alt={alt} className={className}/>
        </>
    )
}